export default __webpack_public_path__ + "static/media/12.169c4706.jpg";